function checkFieldValid(field) {
    if (field.type === 'radio' ) {
        return
    }

    if (field.type === 'checkbox' ) {
        if(field.hasAttribute('required')) {
            field.classList.add('incorrect');
        }
        return
    }

    if (field.value.length === 0 && field.hasAttribute('required')) {
        field.classList.add('incorrect');
        field.classList.remove('success');
        return
    }

    if( (field.id == 'telephone_number' || field.id == 'mobile_number') && field.pattern ) {
        const reg = new RegExp(field.pattern);
        const hint = field.title ? field.title : 'Wrong number of characteres'
        const parent = field.closest('.form-group');
        const messageElement = document.createElement('span');
        messageElement?.classList.add('incorrect-message');
        messageElement?.appendChild(document.createTextNode(hint));
        if (field.value.length > 0) {
            if( !reg.test(String(field.value)) ) {
                field.classList.add('incorrect');
                field.classList.remove('success');
                if(!parent.querySelector('.incorrect-message')) parent?.appendChild(messageElement);
                return
            } else {
                field.classList.remove('incorrect');
                parent?.querySelector('.incorrect-message')?.remove();
                field.classList.add('success');
            }
        }
      }

      if (field.type === 'email') {
        if (!field.hasAttribute('required') && field.value.length === 0) {
            field.classList.remove('incorrect');
            field.classList.remove('success');
            return
        }

        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(String(field.value).toLowerCase())) {
            field.classList.add('incorrect');
            field.classList.remove('success');
            return
        }
    }

    if (field.value.length === 0) {
        field.classList.remove('incorrect');
        field.classList.remove('success');
        return
    }

    field.classList.remove('incorrect');
    field.classList.add('success');
    return
}

function validateFormFieldsOnBlur() {
    const forms = document.querySelectorAll('[data-js-form-blur]');
    if(!forms) return;

    forms.forEach(form => {
        const fieldsInputs = form.querySelectorAll('input, textarea, select');

        if(!fieldsInputs) return;

        fieldsInputs.forEach(field => {
            field.addEventListener('blur', function () {
                checkFieldValid(this);
            })
        })
    });
}

validateFormFieldsOnBlur()